<template>
  <div class="row">
    <div class="left-column"></div>
    <div class="right-column">
      <div class="main-input-form-container">
        <div class="gemnote-logo">
          <img src="../assets/gemnote_logo_pebble.png" alt="logo" />
        </div>

        <section v-if="!loadStatus">
          <Loading text="Loading..." />
        </section>

        <section v-if="loadStatus">
          <template v-if="individualInvitation.succeed">
            <form @click.prevent>
              <h3 data-testid="success-message">Success!</h3>
              <h4>You may now access your team's dashboard</h4>
              <button
                class="button-gemnote button-gemnote--medium left"
                @click="goToDashboard"
              >
                <span>Go to dashboard</span>
              </button>
            </form>
          </template>
          <template v-else-if="individualInvitation.state === 'pending'">
            <form @click.prevent>
              <h3 data-testid="welcome-message">
                Welcome! We're so glad you're here.
              </h3>
              <div class="form-group">
                <input
                  data-testid="firstname-input"
                  placeholder="First Name"
                  class="form-control"
                  v-model="individualInvitation.userName"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  data-testid="lastname-input"
                  placeholder="Last Name"
                  class="form-control"
                  v-model="individualInvitation.userLastName"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  data-testid="email-input"
                  placeholder="Work Email"
                  class="form-control"
                  readonly="true"
                  v-model="individualInvitation.email"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  data-testid="password-input"
                  placeholder="Password"
                  class="form-control"
                  type="password"
                  v-model="individualInvitation.password"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  data-testid="retypepassword-input"
                  placeholder="Re-enter password"
                  class="form-control"
                  type="password"
                  v-model="individualInvitation.reTypePassword"
                  required
                />
              </div>
              <div class="sign-button">
                <button
                  data-testid="accept-invite-button"
                  class="button-gemnote button-gemnote--medium"
                  @click="acceptInvitation"
                >
                  <span>Register</span>
                </button>
              </div>
              <p>
                Already have an account?
                <strong>
                  <router-link :to="{ name: 'login' }" class="link"
                    >Login</router-link
                  >
                </strong>
              </p>
            </form>
          </template>
          <template v-else-if="individualInvitation.state === 'canceled'">
            <form @click.prevent>
              <h1 data-testid="canceled-message">
                Your invitation has been canceled!
              </h1>
            </form>
          </template>
          <template v-else-if="individualInvitation.state === 'accepted'">
            <form @click.prevent>
              <h1 data-testid="accepted-message">
                You have already accepted this invitation.
              </h1>
              <p>
                Already have an account?
                <strong>
                  <router-link :to="{ name: 'login' }" class="link"
                    >Login</router-link
                  >
                </strong>
              </p>
            </form>
          </template>
          <template v-else>
            <form @click.prevent>
              <h2 data-testid="notfound-message">
                We couldn't find your invitation.
              </h2>
            </form>
          </template>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, progressStatus } from '../helpers'

export default {
  name: 'MemberAcceptInvite',
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
    this.$store.dispatch('team/getInvitationDetails', this.$route.params.token)
  },
  computed: {
    ...mapState({
      individualInvitation: state => state.team.individualInvitation,
      loadMembers: state => state.team.loadMembers,
      loadStatus() {
        return progressStatus(this.loadMembers)
      }
    })
  },
  methods: {
    acceptInvitation() {
      this.$store.dispatch('team/acceptInvitation', this.individualInvitation)
    },
    goToDashboard() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  grid-template-rows: auto;
  height: 100vh;
}

.left-column {
  background: url('../assets/Gemnote_SignOn.png');
  background-size: cover;
  background-position: center;
}

.gemnote-logo {
  text-align: left;
  img {
    height: 4rem;
  }
}

.main-input-form-container {
  padding: 8rem;
}

form {
  margin-top: 6rem;

  h1 {
    text-align: left;
    margin-bottom: 2rem;
  }

  h2 {
    margin-bottom: 2rem;
    text-align: left;
  }

  h3 {
    margin-bottom: 2rem;
    text-align: left;
    margin-bottom: 2rem;
  }

  h2 {
    margin-bottom: 2rem;
    text-align: left;
  }

  h3 {
    margin-bottom: 2rem;
    text-align: left;
  }

  h4 {
    margin-top: 1rem;
    margin-bottom: 2rem;
    text-align: left;
  }

  .sign-button {
    padding-top: 2rem;
    padding-bottom: 2rem;
    text-align: left;
  }

  p {
    text-align: left;
  }
}

.left {
  float: left;
}

@media screen and (max-width: 1500px) and (min-width: 900px) {
  .main-input-form-container {
    padding: 6rem;
  }
}

@media (max-width: 1100px) {
  .row {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    transition: 1s ease-in;
  }

  .left-column {
    height: 50vh;
  }

  .right-column {
    height: 50vh;
  }

  .gemnote-logo {
    padding-bottom: 1rem;
  }

  .main-input-form-container {
    padding: 2rem;
  }

  form {
    margin: 0 auto;

    .sign-button {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    p {
      margin: 0rem 0rem;
    }
  }
}
</style>
